import { useState } from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { loadStripe } from '@stripe/stripe-js';
import { userSession } from '../utils/userSession.js';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

export default function CreateSubscription({ isOpen, onClose, partnerId }) {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubscribe = async () => {
    setIsLoading(true);
    setError('');

    try {
      console.log('Starting subscription process');
      const stripe = await stripePromise;
      
      const userData = userSession.getUser();
      
      const successUrl = new URL(`${window.location.origin}`);
      successUrl.searchParams.append('session_id', '{CHECKOUT_SESSION_ID}');
      successUrl.searchParams.append('user_data', JSON.stringify(userData));
      successUrl.searchParams.append('show_dashboard', 'true');
      successUrl.searchParams.append('refresh_data', 'true');

      const response = await fetch(
        'https://r7ej0e9i28.execute-api.ap-southeast-2.amazonaws.com/dev/create-subscription',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            partnerId,
            userId: userSession.getUserId(),
            successUrl: successUrl.toString(),
            cancelUrl: window.location.origin,
          }),
        }
      );

      const data = await response.json();
      console.log('Subscription response:', data);

      if (data.error) {
        throw new Error(data.error + (data.details ? `: ${data.details}` : ''));
      }

      // Use Stripe's redirectToCheckout instead of window.open
      const { error } = await stripe.redirectToCheckout({
        sessionId: data.id
      });

      if (error) {
        throw new Error(error.message);
      }

      onClose();
    } catch (err) {
      console.error('Subscription error:', err);
      setError(err.message || 'Failed to create subscription. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 z-50 flex justify-center items-center">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md">
        <div className="flex items-center justify-between px-6 py-4 border-b">
          <h2 className="text-xl font-semibold text-gray-900">Create Subscription</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <XMarkIcon className="h-6 w-6" />
          </button>
        </div>

        <div className="p-6">
          <div className="mb-6">
            <h3 className="text-lg font-medium text-gray-900 mb-2">
              DriftCal Partner Subscription
            </h3>
            <p className="text-sm text-gray-600">
              Get access to all partner features including:
            </p>
            <ul className="mt-2 space-y-1 text-sm text-gray-600">
              <li>• Banner advertising on event pages</li>
              <li>• Featured listing in partners directory</li>
              <li>• Access to opt-in user data</li>
              <li>• Live analytics</li>
            </ul>
          </div>

          {error && (
            <div className="mb-4 text-sm text-red-600 text-center">
              {error}
            </div>
          )}

          <button
            onClick={handleSubscribe}
            disabled={isLoading}
            className="w-full rounded-md bg-slate-900 px-3 py-2 text-sm font-semibold text-white hover:bg-slate-700 disabled:bg-slate-400"
          >
            {isLoading ? 'Processing...' : 'Subscribe Now'}
          </button>
        </div>
      </div>
    </div>
  );
} 